import React, { Component } from 'react';
import { Row, Col, Media } from 'react-bootstrap';
import HeaderLogo from '../Components/HeaderLogo';
import HeaderTitle from '../Components/HeaderTitle';
import Navigation from '../Components/Navigation';
import Footer from '../Components/Footer';
import { MORSContainer, NavHeader, NavSpan } from '../../theme/MorsTheme';
import LogoutBtn from '../Components/LogoutBtn';
import PdfDocument from '../../components/PdfDocument';

class PrintPreview extends Component {
    constructor(props) {
        super(props);
        this.onFinishedLoading = this.onFinishedLoading.bind(this);
        this.state = {
            printPreview: false,
            allLoaded: false
        }
    }

    onFinishedLoading() {
    }
    render() {
        return (
            <>

            </>
        );
    }
}

const PrintLayout = ({ component: Component, ...props }) =>
    (
        <>

            <div className="printable-area print-layout">
                <PdfDocument pdfData = {props.pdfFile} />
            </div>
            <div className="no-print">
                <MORSContainer>
                    <Row>
                        <Col as={Col} md={3} sm={12} xs={12} >
                            {/* <Row noGutters as={Col} md={3} sm={12} xs={12}> */}
                            <Row noGutters>
                                <Col className="col-3">
                                    <Media style={{ paddingTop: '20px' }}>
                                        <HeaderLogo />
                                    </Media>
                                </Col>
                                <Col style={{ paddingTop: '20px' }} className="d-block d-sm-none col-9">
                                    <LogoutBtn {...props} />
                                </Col>
                            </Row>

                            <Row noGutters className="d-none d-sm-block">
                                <Col as={Col}>
                                    <NavHeader><NavSpan>NAVIGATE</NavSpan></NavHeader>
                                    <Navigation show={true} {...props} />
                                </Col>
                            </Row>
                        </Col>
                        <Col as={Col} md={9} sm={12} xs={12} className="d-md-block">

                            <HeaderTitle {...props} />

                            <Component {...props} />

                            {/* VISIBLE ONLY ON MOBILE */}
                            <Col as={Col} md={3} sm={12} xs={12}>
                                <Row noGutters style={{ paddingTop: '20px' }} className="d-block d-sm-none">
                                    <Col as={Col}>
                                        <Navigation show={true} {...props} />
                                    </Col>
                                </Row>
                            </Col>

                            <Footer {...props} />

                        </Col>

                    </Row>
                </MORSContainer>
            </div>
        </>


    );

export default PrintLayout;